type NativeMessageHandler = {
	postMessage: (message: string) => void;
};

type AndroidThreeDMapBridge = {
	sendReady?: () => void;
	sendLoaded?: () => void;
	sendError?: (message: string) => void;
};

type IOSMessageHandlers = {
	iOSSendReady?: NativeMessageHandler;
	iOSSendLoaded?: NativeMessageHandler;
	iOSSendError?: NativeMessageHandler;
};

declare global {
	interface Window {
		ReactNativeWebView?: NativeMessageHandler;
		AndroidThreeDWebMessage?: AndroidThreeDMapBridge;
		webkit?: {
			messageHandlers?: IOSMessageHandlers;
		};
	}
}

const errorMessage = (error: unknown) => {
	const message = error instanceof Error ? error.message : String(error);
	return message.slice(0, 500) || "Unknown 3D map error";
};

export const parseNativePayload = <T>(
	value: T | string | null | undefined,
	fallback: T,
): T => {
	if (typeof value === "string") {
		return value.trim() ? (JSON.parse(value) as T) : fallback;
	}
	return value ?? fallback;
};

export const notifyNativeThreeDMapReady = () => {
	window.ReactNativeWebView?.postMessage("ready");
	window.AndroidThreeDWebMessage?.sendReady?.();
	window.webkit?.messageHandlers?.iOSSendReady?.postMessage("ready");
};

export const notifyNativeThreeDMapLoaded = () => {
	window.ReactNativeWebView?.postMessage("loaded");
	window.AndroidThreeDWebMessage?.sendLoaded?.();
	window.webkit?.messageHandlers?.iOSSendLoaded?.postMessage("loaded");
};

export const notifyNativeThreeDMapError = (error: unknown) => {
	const message = errorMessage(error);
	window.ReactNativeWebView?.postMessage(`error|${message}`);
	window.AndroidThreeDWebMessage?.sendError?.(message);
	window.webkit?.messageHandlers?.iOSSendError?.postMessage(message);
};

export const runThreeDMapInitialization = async (
	initialize: () => Promise<void>,
	onError: (error: unknown) => void,
) => {
	try {
		await initialize();
		return true;
	} catch (error) {
		onError(error);
		return false;
	}
};
